

























































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
// import pushSettingDialog from "../educational/pushSettingDialog.vue";
import {
  dateFormat,
  getLatestMonth,
  getCurrentMonth,
} from "@/utils/timeFormat";
import {
  statisticsExperienceDataInter,
  statisticsExperienceDataApi,
} from "@/api/statistics";
import courseTable from "./courseTable.vue";
import teacherTable from "./teacherTable.vue";
import channelTable from "./channelTable.vue";
import buyTable from "./buyTable.vue";
import appears from "./appears.vue";
import { roundNumbers } from "@/utils/roundNumbers";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  components: {
    // pushSettingDialog,
    courseTable,
    teacherTable,
    channelTable,
    buyTable,
    appears,
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo: any = {
    date: [],
    range: "month",
    teacher_id: "" as number | string,
    course_type: -1,
  };
  currentTimeType: string = "day";
  currentTimeRange: string[] = [];
  checkTabs: number = 1;
  comprehensiveData: any = [];
  created() {
    this.searchRangeChange("month");
  }
  goTetail(val: any) {
    if (val.key === "hover") {
      const goExperience = this.$router.resolve({
        name: "experience",
        query: {
          s_time: this.currentTimeRange[0],
          e_time: this.currentTimeRange[1],
          from: "experience",
          val: "all",
        },
      });
      window.open(goExperience.href, "_blank");
    }
  }
  // 搜索交互
  searchDateChange(dates: string[]) {
    console.log("searchDateChange", dates);
    if (!dates) {
      // 清除
      this.searchInfo.range = "month";
      this.currentTimeRange = [];
      this.searchRangeChange("month");
    } else {
      this.currentTimeRange = dates || [];
      this.searchInfo.range = "free";
      this.renderTotal();
    }
  }
  searchRangeChange(type: string) {
    let start: string = "";
    let end: string = "";
    const now = new Date();
    switch (type) {
      case "month":
        const monthArr = getCurrentMonth(now);
        start = dateFormat("YYYY-mm-dd", monthArr[0]);
        end = dateFormat("YYYY-mm-dd", monthArr[1]);
        break;
      case "last_month":
        const d = now.getDate();
        const lastMonthArr = getCurrentMonth(
          now.getTime() - d * 24 * 60 * 60 * 1000
        );
        start = dateFormat("YYYY-mm-dd", lastMonthArr[0]);
        end = dateFormat("YYYY-mm-dd", lastMonthArr[1]);
        break;
      case "three_month":
        start = getLatestMonth(3);
        end = dateFormat("YYYY-mm-dd", now);
        break;
      case "six_month":
        start = getLatestMonth(6);
        end = dateFormat("YYYY-mm-dd", now);
        break;
      case "twelve_month":
        start = getLatestMonth(12);
        end = dateFormat("YYYY-mm-dd", now);
        break;
    }
    this.currentTimeRange = [start, end];
    this.searchInfo.range = type;
    this.searchInfo.date = [start, end];
    this.renderTotal();
  }
  renderTotal() {
    const params: statisticsExperienceDataInter = {
      time_tag: this.searchInfo.range,
      start_date: this.currentTimeRange[0],
      end_date: this.currentTimeRange[1],
    };
    statisticsExperienceDataApi(params).then((res: any) => {
      if (res.error_code === 0) {
        this.comprehensiveData = [];
        const r = res.data;
        const experienceArr = {
          title: "体验数据",
          popover1: "预约体验数: 查询时间内所有需要体验的记录数",
          popover2: "1vN体验数: 查询时间内1vN需体验的记录数",
          popover3: "1v1体验数: 查询时间内1v1需体验的记录数",
          // popover4: "完成体验数: 查询时间内完成体验的记录数，状态为“已体验”",
          popover4: "完成体验数: 1v1完成体验数+1vN完成体验数",
          popover5: "完成体验率: 完成体验率 = 完成体验数 / 预约体验数 * 100%",
          n: 1,
          arr: [
            {
              name: "预约体验数",
              num: r.invited_count,
            },
            {
              name: "1vN体验数",
              num: r.invited_count_1vn,
            },
            {
              name: "1v1体验数",
              num: r.invited_count_1v1,
            },
            {
              name: "完成体验数",
              num: r.finish_count,
            },
            {
              name: "1v1完成体验数",
              num: r.invited_count_1v1_finish_count,
            },
            {
              name: "1vN完成体验数",
              num: r.invited_count_1vn_finish_count,
            },
            {
              name: "完成体验率",
              num: roundNumbers(r.finish_rate) + "%",
            },
          ],
        };
        const convertArr: any = {
          title: "转化数据",
          popover6:
            "体验转化数: 查询时间内完成体验及缴费的记录数，状态为“已体验”、“已缴费”",
          popover7: "体验转化率: 体验转化率 = 体验转化数 / 完成体验数 * 100%",
          popover8:
            "转化金额: 查询时间内完成体验及缴费的记录金额，状态为“已体验”、“已缴费”",
          popover9: "1vN金额: 已转化订单金额中，1vN金额数",
          popover10: "1v1金额: 已转化订单金额中，1v1金额数",
          n: 2,
          arr: [
            {
              name: "体验转化数",
              num: r.transform_count,
              key: "hover",
            },
            {
              name: "体验转化率",
              num: roundNumbers(r.transform_rate) + "%",
            },
            {
              name: "转化金额",
              num: roundNumbers(r.transform_amount),
            },
            {
              name: "1vN金额",
              num: roundNumbers(r.transform_amount_1vn),
            },
            {
              name: "1v1金额",
              num: roundNumbers(r.transform_amount_1v1),
            },
          ],
        };
        this.comprehensiveData.push(experienceArr, convertArr);
      }
    });
  }
}
